import axios from "axios";

import {
  PickupRequestsListRequest,
  PickupRequestsListResponse,
} from "fe-shared-requests/src/types";

import { PAGE_SIZE } from "consts";

type RequestParams = Pick<
  PickupRequestsListRequest,
  "filteringParameters" | "sortingBy"
>;

// The gateway resolves the caller's company from the auth token - a client-supplied companyId
// would be ignored, so none is sent.
export const getRequests = (
  _queryKey: string,
  requestParams: RequestParams,
  page: number | null = 1
): Promise<PickupRequestsListResponse> =>
  axios
    .post<PickupRequestsListResponse>("pickupRequests/getPickupRequests", {
      ...requestParams,
      limit: page === null ? undefined : PAGE_SIZE,
      skip: page === null ? 0 : (page - 1) * PAGE_SIZE,
    })
    .then((res) => res.data);

export default getRequests;
